<template>
    <div class="habit-page">
        <div class="row mt-2">
            <div class="col-lg-11 col-11 mx-auto">
            <!-- <div class="small-box bg-warning card d-flex flex-row justify-content-between">
                <h4 class="p-2">Building and Maintaining Myself:</h4>
            </div> -->
                <div class="card card-widget widget-user">
                    <div class="widget-user-header text-white"
                        style="background: url('/assets/images/pexels-andrea-piacquadio-903171_group_fitness.jpg')  center;">
                        <h2 class="widget-user-desc  text-left heading-border">Lifting myself to My Best Physical State</h2>
                        <h2 class="widget-user-desc text-right heading-border">Challenging-Movement >>>> Improvement,</h2>
                        <h4 class="widget-user-desc text-right heading-border">Systematic progress</h4>
                    </div>
                    <div class="widget-user-image">
                        <img class="img-circle" src="/assets/images/pexels-andrea-piacquadio-3768593_fitness128x128.jpg" alt="User Avatar">
                    </div>
                </div>

                <div class="card row text-center" >
                    <div class="row .flex-row justify-content-between" style="padding:.5em;">
                    <h2 class="m-2 col-sm-4" >My Workout Schedule</h2>
                        <button class="btn btn-sm btn-success mb-2  col-sm-3 " style="max-height:2em;" @click="exitToDash" >Back to My Future Self Dashboard</button>
                        <!-- <button class="btn btn-sm btn-success  col-sm-3" style="max-height:2em;" @click="downloadPrintable" >Download Printable Workout</button> -->
                    </div>
                </div>
                <div class="row">
<!--Use suggestions here to fix visiblity: https://stackoverflow.com/questions/55031374/problems-displaying-a-table-on-mobile-version-of-my-site-->
<!--TODO: TRANSFER TO FLEXBOX TABLE: https://codepen.io/tsnkff/pen/MPqPyJ-->
                    <!-- <div class="col-sm-12 col-md-12 bordered">
                        <div class="color-palette-set">
                                <div class="col-lg-6 col-sm-6 mx-auto m-2" style="margin:.5em;" v-for="aworkout in workoutNums" :key="aworkout.workout_num">
                                <div class="row mt-2 justify-content-between">
                                    <div class="content-box-gray card" >
                                        <div class="title" style="content-align:center;">
                                        <h2 style="margin:auto;color:#222;" class="text-center mt-1" v-html="getBoxTitle(aworkout.workout_num)"></h2>
                                        </div>
                                        <div class="content" style="max-width:100%; overflow-x:auto;">
                                            <table class="table table-responsive table-dark table-striped table-bordered table-sm" style="width:100%;font-size:1rem;">
                                                <thead>
                                                    <tr><th>BodyPart:</th><th>Movement:</th><th data-toggle='tooltip' data-placement='top' :title='setsRepsToolTipText()'>Sets/Reps</th>
                                                    <th data-toggle='tooltip' data-placement='top' :title='tempoToolTipText()'>Tempo</th><th>Rest</th></tr>
                                                </thead>
                                                <tbody>
                                                <tr  v-for="awrk in getDaysWorkouts(aworkout.workout_num)" :key="awrk.movement_id">
                                                    <td  xx='BodyPart'>{{awrk.bodypart}}</td>
                                                    <td  xx='Movement'>
                                                        <i class="fa fa-tv" style="color:#e5bc17;text-align: left;" aria-hidden="true"  @click="showVideoModal(awrk)"></i>
                                                        &nbsp;{{awrk.movementname}}
                                                    </td>
                                                    <td xx='SetsReps' :title='setsRepsToolTipText()'>{{awrk.setsreps}}</td>
                                                    <td  xx='Tempo' :title='tempoToolTipText()'>{{awrk.tempo}}</td>
                                                    <td  xx='Rest'>{{awrk.rest}}</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->

<!-- ====================================================-->
<div class="wrk-container">
<div class="col-sm-12 col-md-12 bordered">
                        <div class="color-palette-set">
                                <div class="col-lg-6 col-sm-12 mx-auto m-2" style="margin:.5em;" v-for="aworkout in workoutNums" :key="aworkout.workout_num">
                                <div class="row mt-2 justify-content-between">
                                    <div class="content-box-gray card" >
                                        <div class="title" style="content-align:center;">
                                        <h2 style="margin:auto;color:#222;" class="text-center mt-1" v-html="getBoxTitle(aworkout.workout_num)"></h2>
                                        </div>
                                        <div class="content" style="max-width:100%; overflow-x:auto;">
  <div class="table-container">
    <div class="table-row heading">
      <div class="row-item" style="width:23%;">Body<br/>-Part</div>
      <div class="row-item" style="width:30%;">Movement </div>
      <div class="row-item" style="width:24%;" data-toggle='tooltip' data-placement='top' :title='setsRepsToolTipText()'>Sets<br/>/Reps</div>
      <div class="row-item" style="width:15%;" data-toggle='tooltip' data-placement='top' :title='tempoToolTipText()'>Tempo</div>
<div class="row-item" style="width:9%;">Rest</div>
    </div>

<div class="table-row" v-for="awrk in getDaysWorkouts(aworkout.workout_num)" :key="awrk.movement_id">
      <div class="row-item" style="width:23%;">{{awrk.bodypart}}</div>
     <div class="row-sub-container" style="width:30%;">
        <div class="row-item"><i class="fa fa-tv" style="color:#e5bc17;text-align: left;" aria-hidden="true" @click="showVideoModal(awrk)" ></i></div>
        <div class="row-item">{{awrk.movementname}}</div>
      </div>
      <div class="row-item" style="width:24%;" :title='setsRepsToolTipText()'>{{awrk.setsreps}}</div>
      <div class="row-item" style="width:15%;" :title='tempoToolTipText()'>{{awrk.tempo}}</div>
<div class="row-item" style="width:9%;">{{awrk.rest}}</div>
    </div>


</div>


    <!-- <div class="table-row">
     <div class="row-item">Shoulders</div>
 <div class="row-sub-container">
        <div class="row-item"><i class="fa fa-tv" style="color:#e5bc17;text-align: left;" aria-hidden="true" ></i></div>
        <div class="row-item">Pike Pushups</div>
      </div>
      <div class="row-item">3-4 x 8-12</div>
      <div class="row-item">4131</div>
 <div class="row-item">60</div>
    </div> -->


                                        </div></div></div></div></div></div>
</div>

<!-- ====================================================-->
                </div>
            </div>
        </div>
<!-- <div visible="hidden" id="exportTable"></div> -->
        <div hidden v-if="genDownloadWorkout" v-html="generateWorkoutRows()"></div>
    </div>
</div>
</template>

<script>

import axios from 'axios';
import Swal from 'sweetalert2';
var _ = require('lodash');
import { v4 as uuidv4 } from 'uuid';
import EventBus from '../../event-bus';


export default {
    components:{

     },
    name: "MyWorkout",
    data() {
        return {
            // token: document.head.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            loading: false,
            errors: {
                header: '',
                hc_add: '',
            },
            allmovements:[],
            userinfo:'',
            sel_workout_type:'',
            userprefsData:'',
            myworkoutData:'',
            tableBodyRows:'',
            alternateBodyPartEx:'',
            workoutRows:'',
            videoURL:'',
            selfEval: false, //Keeep false until implemented
            weeknums:[],
            numDaysAvailable:'',
            dayOfWeekNum:0,
            genDownloadWorkout:false,
            workoutNums:[]
        }
    },

    props: {
        userdata:'',
        userprefs:'',
        myworkouts:[],
        workout:'',
        workout_nums: [],
    },
    mounted() {
        this.userinfo = JSON.parse(this.userdata);
        this.userprefsData = JSON.parse(this.userprefs);
         this.myworkoutData = JSON.parse(this.workout);
 this.workoutNums = JSON.parse(this.workout_nums);
        this.workoutRows = this.generateWorkoutRows();
        this.numDaysAvailable =  this.userprefsData.numdaysavailable;
        // this.setupButtonListeners();
        // this.prepVideo();
        // this.groupFunction();
        this.weeknums = this.genWeeks();
    },

    methods: {
        setupDownloadTable() {
            this.genDownloadWorkout = true;
            this.tableToExcel('exportTable');
        },
        getBoxTitle(workout) {
            //  console.log("getBoxTitle: " + workout);
            return this.getWeekName(workout) + ", " +this.getNumOfWeekWorkout(workout);
        },
        showVideoModal(wrkout) {
            const payload = {workout: wrkout,};
            EventBus.$emit('displayVideoModal', payload);
        },
        getWeekName(workoutnum) {
            return "Week:" + parseInt(Math.ceil(workoutnum/this.numDaysAvailable));
        },
        getNumOfWeekWorkout(workoutnum) {
            return "Day: " + parseInt(this.getPureNumOfWeekWorkout(workoutnum));

        },
        getPureNumOfWeekWorkout(workoutnum) {
            var theNum = parseInt((workoutnum%this.numDaysAvailable));
            if(theNum == 0) theNum = this.numDaysAvailable;
            return theNum;
        },
        getDayOfWeekNum(){
            this.dayOfWeekNum++;
            if (this.dayOfWeekNum > this.numDaysAvailable) {
                this.dayOfWeekNum = 1;
            }
            return this.dayOfWeekNum;
            // return 0;
        },
        setsRepsToolTipText()  {
            return 'e.g., 3-4 x 10-12 = 3-4sets, fail at 10-12 reps';
        },
        tempoToolTipText() {
            return 'e.g., 4112 = 4s down, 1s stop, 1s up, 2s hold';
        },
        getWeekWorkouts(weeknum){
            // console.error("Looking for weeknum:"  + weeknum);
           var weeksWorkouts = [];
            [...this.myworkoutData].map((aWorkout)=> {
                // console.log(aWorkout.workout_num);
                if(aWorkout.workout_num == weeknum) {
                        // console.log("Found match: " + aWorkout.movementname);
                        weeksWorkouts.push(aWorkout);
                    }
                });
            // console.log(weeksWorkouts);
            return weeksWorkouts;
        },
        getDaysWorkouts(workoutnum){
          var weeknum=  this.getPureNumOfWeekWorkout(workoutnum);
           var daysWorkouts = [];
            // [...this.myworkoutData].map((aWorkout)=> {
[...this.myworkoutData].filter((aWorkout)=> {
                if(aWorkout.workout_num == weeknum) {
                        daysWorkouts.push(aWorkout);
                    }
                });
        return daysWorkouts;
        },


        exitToDash() {
            location.replace('/fself/')
        },
        downloadPrintable(){
            this. setupDownloadTable();
        },
        onlyUnique(value, index, self) {
            return self.indexOf(value) === index;
        },
        genWeeks(){
            var retvals = [...this.myworkoutData].map((v, i, a) =>{
                 return v.workout_num;
            });
            retvals = retvals.filter(this.onlyUnique);
            // console.log(retvals);
            return retvals;
        },
        getAlternateBodyPartExercise(movement_id, bodypart){
               axios.post('/workout/movement/alternate', {
                movement_id:movement_id,
                bodypart: bodypart
            })
            .then(res => {
                this.loading = false;
                this.success = true;
                this.message = res.data.message;
                this.alternateBodyPartEx= JSON.parse(res.data.altexercise);
                // console.error(res.data.message);
            })
            .catch(err => {
                // this.loading = false;
                // this.failure = true;
                console.error(err);
            })
            .finally(()=> {
                // location.reload();
                //   this.updateToast(this.message, 4000);
                this.message = '';
            });
            return this.alternateBodyPartEx;
        },
        generateWorkoutRows(){
// https://stackoverflow.com/questions/37723448/how-to-make-responsive-table-without-using-bootstrap
            var tableBodyRows = '';
            var movArr = [];
            var dayOfWeekNum = 1;
            var prevWorkoutNum = 0;
            var compWeekNum  = 0;//shows if loop is in new week
            var tempoToolTipText = 'e.g., 4112 = 4s down, 1s stop, 1s up, 2s stop';
            var setsRepsToolTipText = 'e.g., 4 x 10-12 = 4sets, fail at 10-12 reps';
            var numDaysAvailable = this.userprefsData.numdaysavailable;
            [...this.myworkoutData].forEach(element => {
                // Array.from(this.myworkoutData).forEach(element => {
                // Array.prototype.forEach.call(this.myworkoutData, element => {

                var movementID = element.movement_id;
                var bodyPart = element.bodypart;
                var videoURL = element.videourl;
                var thisWorkoutNum = element.workout_num;
                var movementName = element.movementname;
                var setsReps = element.setsreps;
                var temPo =  element.tempo;
                var resT =  element.rest;
                var workoutSplit = element.workout_split;
                compWeekNum = thisWorkoutNum % numDaysAvailable;// return 1 for the first day of the workout-week
                var weekNum = Math.ceil(thisWorkoutNum / numDaysAvailable);
                // console.log("wrkNo: "  + thisWorkoutNum +  ", weekNo:" + weekNum +", prev:" + prevWorkoutNum + ", compWeekNum");
                   if((thisWorkoutNum != prevWorkoutNum) && compWeekNum == 1){
                //    console.log("Printing Week Header: WEEK: "+ weekNum);
                   tableBodyRows += `<table id="exportTable"><tr> <th colspan='6'></th></tr><tr class="bg-primary">
                        <th colspan='6'>
                        <h4 class='text-center'>Workouts for Week `+ parseInt(weekNum) + `:</h4>
                        </th>
                    </tr>`;
                }
                if (thisWorkoutNum != prevWorkoutNum) { //process for header of new day/workout
                    // console.log("Printing Day Header: Day: "+ dayOfWeekNum);
                    tableBodyRows += "<tr class='bg-primary'><th colspan='6'><h6 class='text-center'>Day: " + dayOfWeekNum + "</h6></th></tr>";
                    tableBodyRows += "<tr><th></th><th >BodyPart: </th><th>Exercise:</th><th data-toggle='tooltip' data-placement='top' title='"+setsRepsToolTipText+"'>Sets/Reps</th>";
                    tableBodyRows += "<th data-toggle='tooltip' data-placement='top' title='"+tempoToolTipText+"'>Tempo</th><th>Rest</th></tr>";
                    dayOfWeekNum++;
                    if (dayOfWeekNum > numDaysAvailable) {
                        dayOfWeekNum = 1;
                    }
                } //else
                if (thisWorkoutNum == prevWorkoutNum) {
                    if (movArr.includes(movementID)) {
                        // console.error("found duplicated workout: ". movementID + ", Getting substitute....");
                        var substituteMovement = JSON.parse(this.getAlternateBodyPartExercise(movementID, bodyPart));
                        movementName = substituteMovement.movementname;
                        movementID = substituteMovement.id;
                        videoURL = substituteMovement.videourl;
                    }
                    //push movement name into each day's array for later comparison
                    movArr[movementName] = movementID;
                }
                tableBodyRows += "<tr><th></th><td xx='BodyPart'>"+bodyPart+"</td>";
                tableBodyRows += "<td xx='Exercise'>"+movementName+"<br />";
                // tableBodyRows += `<button id="`+workoutSplit+"_"+movementID+`" type='button' @click="prevVidJS('`+movementName+` technique','`+ videoURL +`');" class='btn btn-primary btn-sm video-btn' data-toggle='modal' data-title='` + movementName + ` Technique' data-src='` + videoURL + `' data-target='#myModal'> Launch Video</button>`;
                tableBodyRows += "</td><td xx='SetsReps'>" + setsReps + "</td><td xx='Tempo'>" + temPo +"</td><td xx='Rest'>" + resT + "</td></tr>";
                prevWorkoutNum = thisWorkoutNum;
            });
            tableBodyRows += "<tr class='bg-primary'><th colspan='6'>";
            tableBodyRows += "<h6 class='text-center'>One (1) Week Active Rest</h6></th></tr></table>";
            return tableBodyRows;
        },
    tableToExcel(table_id, separator = ',') {
        // Quick and simple export target #table_id into a csv from: https://stackoverflow.com/questions/15547198/export-html-table-to-csv-using-vanilla-javascript
        // function download_table_as_csv(table_id, separator = ',') {
        // Select rows from table_id
        var rows = document.querySelectorAll('table#' + table_id + ' tr');
        // Construct csv
        var csv = [];
        for (var i = 0; i < rows.length; i++) {
            var row = [], cols = rows[i].querySelectorAll('td, th');
            for (var j = 0; j < cols.length; j++) {
                // Clean innertext to remove multiple spaces and jumpline (break csv)
                var data = cols[j].innerText.replace(/(\r\n|\n|\r)/gm, '').replace(/(\s\s)/gm, ' ')
                // Escape double-quote with double-double-quote (see https://stackoverflow.com/questions/17808511/properly-escape-a-double-quote-in-csv)
                data = data.replace(/"/g, '""');
                // Push escaped string
                row.push('"' + data + '"');
            }
            csv.push(row.join(separator));
        }
        var csv_string = csv.join('\n');
        // Download it
        var filename = 'export_' + table_id + '_' + new Date().toLocaleDateString() + '.csv';
        var link = document.createElement('a');
        link.style.display = 'none';
        link.setAttribute('target', '_blank');
        link.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv_string));
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    // <a href="#" onclick="tableToExcel('my_id_table_to_export');">Download as CSV</a>
    },

    }
}
</script>

<style scoped>
.content-box-gray .content {
    overflow:    ;
    padding: 10px;
    font-size: 1.2em;
    /* border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em; */
    border: 1px solid rgb(15, 9, 9);
    color: #212c3e;
}
.content-box-gray .title {
    height:4em;
    line-height:1.6em;
    border-top-left-radius: .5em;
    border-top-right-radius: .5em;
    background:#ffc107;
    /* font-size:.75em; */
    font-size:2.0vw;
    /* font-weight:bold; */
    font-family:verdana;
    display:block;
    color:white;
    display:block;
    padding:auto;
    border: 1px solid gray;
    border-bottom:none;
}
h1 {
  font-size: 5.9vw;
}
h2 {
  font-size: 3.0vh;
}
p {
  font-size: 2vmin;
}
.title{
max-height:3.6em !important;
}
.content {
  font-size: calc(100% + 1vw + 1vh);
}
table tr td,table tr td{
		text-align: center;
	}
	@media only screen and (max-width: 500px) {
        table,head,tbody,th,td,tr {
            display: block;
        }
        thead tr {
            display: none;
        }
        tr {
            border: 1px solid #ccc;
        }
        td {
            border: none;
            border-bottom: 1px solid #eee;
            position: relative;
            padding-left: 50%;
            white-space: normal;
            text-align:left;
            min-height: 30px;
            overflow: hidden;
            word-break:break-all;
        }
        td:before {
            position: absolute;
            top: 6px;
            left: 6px;
            width: 45%;
            padding-right: 10px;
            text-align:left;
            font-weight: bold;
            color:#e5bc17;
        /* }
        td:before { */
            content: attr(xx) !important;
        }
}
.heading-border{
    color:#ffffff;
    text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;
/*
  @media  (max-width: 768px)  {
    line-height: 2cap;
  } */
}


.wrk-container {
  width: 100%;
  height: 100%;
  display: flex;
  margin: 0;
  justify-content: center;
  align-items: center;
  background-color: #fafafa;
}

.table-container {
  display: flex;
  flex-flow: column nowrap;
  background-color: white;
  width: 100%;
  margin: 0 auto;
  border-radius: 4px;
  border: 1px solid #DADADA;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, .08);
}

.table-row {
  display: flex;
  flex-flow: row nowrap;
  width: 100%;
  border-bottom: 1px solid #dadada;
}

.heading {
  background-color: #0b0b0b;
  color: #faf6f6;
  font-weight: bold;
}

.row-item {
  display: flex;
  flex: 1;
  font-size: 14px;
  padding: 8px 0;
  justify-content: center;
  align-items: center;
  transition: all 0.15s ease-in-out;
  border:1px solid rgb(211, 207, 207);
  margin:-1px;
}

.row-item:hover {
  cursor: pointer;
  background-color: #F0F0F0;
/*   box-shadow: 0px 1px 4px rgba(0, 0, 0, .08); */
}

.row-sub-container {
  display: flex;
  flex-flow: column nowrap;
  flex: 1;

}

.row-sub-container .row-item {
  padding: 8px 0;
  /* border-bottom: 1px solid #dadada; */
}

.table-row:last-child,
.row-sub-container .row-item:last-child {
  border-bottom: 0;
}

</style>
